function anim() {
/*===========
    Add standard animation
    ===========*/
    const animEl = document.querySelectorAll('[data-anim]');
    
    if(animEl.length > 0) {
        animEl.forEach(el=> {
            const observerAnim = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if(entry.isIntersecting) {
                        let time = entry.target.getAttribute('data-time');
    
                        if(!entry.target.getAttribute('data-time')) {
                            entry.target.classList.add('anim');
                        } else {
                            setTimeout(()=> {
                                entry.target.classList.add('anim');
                            }, time);
                        }
                    }
                });
            }, {threshold: [.3]});
            observerAnim.observe(el);
        });
    }

    const animMomentumEl = document.querySelectorAll('[data-animMomentum]');

    if(animMomentumEl.length > 0) {
        animMomentumEl.forEach(el=> {
            let time = el.getAttribute('data-time');

            if(!el.getAttribute('data-time')) {
                el.classList.add('anim');
            } else {
                setTimeout(()=> {
                    el.classList.add('anim');
                }, time);
            }
        });
    }
}

export default anim;